import { createElement, type ReactNode } from 'react';

/**
 * Hervorhebung aus `ts_headline` sicher darstellen: NUR `<mark>`/`</mark>` werden als Markierung gedeutet,
 * alles andere bleibt Text (React escaped). Verschachtelung/ungepaarte Tags werden toleriert.
 */
export function renderHighlight(highlight: string): ReactNode[] {
  const out: ReactNode[] = [];
  let marked = false;
  let key = 0;
  for (const part of highlight.split(/(<\/?mark>)/i)) {
    const lower = part.toLowerCase();
    if (lower === '<mark>') {
      marked = true;
      continue;
    }
    if (lower === '</mark>') {
      marked = false;
      continue;
    }
    if (!part) continue;
    out.push(createElement(marked ? 'mark' : 'span', { key: key++ }, part));
  }
  return out;
}
